import styled, { css } from "styled-components";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import AtomLogo from "Components/Atoms/Logo";
import AtomBack from "Components/Atoms/NowList/Back";
import AtomNowLogo from "Components/Atoms/NowLogo";
import AtomXSSearchIcon from "Components/Atoms/Search/XSSearchIcon";
import * as Types from "Types";
import * as enums from "enumerations";

const Wrap = styled.div<Types.Default>`
   position: relative;
   padding: 25px 15px 20px 15px;
   box-sizing: border-box;
   ${({ css }) => css}
`;
const LogoWrap = styled.div`
   text-align: center;
`;
const Logo = styled(AtomLogo)`
   & > img {
      height: 15px;
   }
`;

const SearchButton = styled.div<Types.Default>`
   margin-top: 20px;
   display: flex;
   justify-content: space-between;
   align-items: center;
`;

function Header(props: any) {
   const width = useSelector(({ dimensions }: Types.State) => dimensions.width);
   const XSSearchStatus = useSelector(({ XSSearch }: Types.State) => XSSearch.status);
   const navigate = useNavigate();

   let cssSearchButton = css`
      z-index: 100;
      transform: translate(0, 0);
   `;
   switch (XSSearchStatus) {
      case enums.XSSearchStatuses.input:
         cssSearchButton = css`
            z-index: 100;
            transform: translate(${0 - ((width - 253) / 2 - 15)}px, ${31 + 15 + 180 + (35 - 23) / 2}px);
         `;
         break;
      case enums.XSSearchStatuses.openInit:
         cssSearchButton = css`
            z-index: 100;
            transform: translate(${0 - ((width - 253) / 2 - 15)}px, ${31 + 15 + 180 + (35 - 23) / 2}px);
         `;
         break;
      case enums.XSSearchStatuses.closeInit:
         break;
   }

   function backOnClick() {
      navigate(-1);
   }

   return (
      <Wrap css={props.css}>
         <LogoWrap>
            <Logo></Logo>
         </LogoWrap>

         <SearchButton>
            <AtomBack onClick={backOnClick}></AtomBack>
            <AtomNowLogo></AtomNowLogo>
            <AtomXSSearchIcon onClick={props.searchOnClick} css={cssSearchButton}></AtomXSSearchIcon>
         </SearchButton>
      </Wrap>
   );
}

export default Header;
